module.exports = __webpack_public_path__ + "static/instagram-template-ec271fefca9bf61c0a0902acb34cc486.png";